export default __webpack_public_path__ + "static/media/kushtetuta.896aa272.png";